import { IonCol } from '@ionic/react';
import React from 'react';
import { GeolocationInfo } from '../../components/GeolocationInfo';
import { SkeletonText } from '../../components/SkeletonText';
import { useSettings } from '../../contexts/SettingsContext';
import { BaseSection } from '../BaseSection';

export const LocationSection: React.FC = () => {
  const { marker } = useSettings();
  const location = React.useMemo(() => marker?.location, [marker]);

  return (
    <BaseSection title="Location">
      <IonCol>{location ? <GeolocationInfo location={location} /> : <SkeletonText height={10} />}</IonCol>
    </BaseSection>
  );
};
